const percentageFormatter = new Intl.NumberFormat("en-US", {
  unit: "percent",
  style: "unit",
  maximumFractionDigits: 2,
});

export const formatPercentage = (number: number): string => {
  return percentageFormatter.format(number);
};
